// extracted by mini-css-extract-plugin
module.exports = {"selectorWrapper":"pJ0A5Evx","styledIcon":"V71I4RhG"};